export default __webpack_public_path__ + "static/media/family-image.f969edb3.png";